import {createContext, useContext} from 'react';
import { LanguageType } from 'types/LanguageType';

export const LanguageContext = createContext<LanguageType | null>(null);

export function useLanguageContext() {
    const value = useContext(LanguageContext);
    if (value == null)
        throw new Error('LanguageContext is not initialized, please add LanguageContextProvider as parent.');
    return value;
}
